"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Sortable_1 = __importDefault(require("../../../../shared/util/Sortable"));
var SDControlsEditManager = /** @class */ (function () {
    // #endregion Properties (2)
    // #region Constructors (1)
    function SDControlsEditManager(_editMode, _sortManager, _containerClass) {
        if (_containerClass === void 0) { _containerClass = "sdv-control-panel-row-container"; }
        this._editMode = _editMode;
        this._sortManager = _sortManager;
        this._containerClass = _containerClass;
        // #region Properties (2)
        this._components = [];
    }
    // #endregion Constructors (1)
    // #region Public Methods (1)
    SDControlsEditManager.prototype.registerComponent = function (component) {
        var _this = this;
        this._components.push(component);
        this._components = this._sortManager.sort(this._components, false);
        if (this._editMode) {
            component.setEditable(true);
            if (this._sortableCreateTimeout) {
                window.clearTimeout(this._sortableCreateTimeout);
            }
            this._sortableCreateTimeout = window.setTimeout(function () {
                Sortable_1.default.create(document.getElementsByClassName(_this._containerClass)[1], {
                    handle: ".jq-sdv-sort-bars",
                    onEnd: function (evt) {
                        var htmlNodes = document.getElementById("sd-elements-container-parameters").children;
                        var _loop_1 = function (i) {
                            var node = htmlNodes[i];
                            _this._components.find(function (x) { return node.id.includes(x.id); }).order = i;
                        };
                        for (var i = 0; i < htmlNodes.length; i++) {
                            _loop_1(i);
                        }
                    }
                });
            }, 1000);
        }
    };
    return SDControlsEditManager;
}());
exports.SDControlsEditManager = SDControlsEditManager;
